import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tryout-fee-today-income',
  templateUrl: './tryout-fee-today-income.component.html',
  styleUrls: ['./tryout-fee-today-income.component.css']
})
export class TryoutFeeTodayIncomeComponent implements OnInit {
  @Input() NoOfTodayIncome: string;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-fee-today-income/tryout-fee-today-income.component.ts